module.exports = __webpack_public_path__ + "static/media/1019059.67d84f45.jpg";